<template>
  <a-card :bordered="false">
    <div style='margin-top: 10px;margin-bottom: 10px;'>
    </div>
    <div v-show="!stampShowed">
      <div id="pdfCentent">
        <a-row :gutter="[16,32]">
          <a-col :span="12" :offset="4" style='text-align: center'>
            <h2>评标基准价计算</h2>
          </a-col>
        </a-row>

        <a-row :gutter="[16,32]">
          <a-form-model-item :label-col="{span: 4, offset: 4}" :wrapper-col="{span: 4}" label="最高投标限价：">
            <a-input :value="controlPrice " disabled='disabled' />
          </a-form-model-item>
        </a-row>
        <a-row :gutter="[16,32]">
          <a-form-model-item :label-col="{span: 4, offset: 4}" :wrapper-col="{span: 4}" label="评标价最高限价：">
            <a-input :value="evalControlPrice " disabled='disabled' />
          </a-form-model-item>
        </a-row>
        <a-row :gutter="[16,32]">
          <a-form-model-item :label-col="{span: 4, offset: 4}" :wrapper-col="{span: 4}" label="进入评标基准价下限：">
            <a-input :value="benchmarkPriceDown" disabled='disabled' />
          </a-form-model-item>
        </a-row>
        <a-row :gutter="[16,32]">
          <a-form-model-item :label-col="{span: 4, offset: 4}" :wrapper-col="{span: 4}" label="暂列金额：">
            <a-input :value="tentativeAmount" disabled='disabled' />
          </a-form-model-item>
        </a-row>
        <a-row :gutter="[16,32]">
          <a-form-model-item :label-col="{span: 4, offset: 4}" :wrapper-col="{span: 4}" label="有效评标价算术或加权平均值：">
            <a-input :value="benchmarkPriceAvg" disabled='disabled' />
          </a-form-model-item>
        </a-row>
        <a-row :gutter="[16,32]">
          <a-form-model-item :label-col="{span: 4, offset: 4}" :wrapper-col="{span: 15}" label="下浮率：">
            <a-input :value="floatRate + '%' " disabled='disabled' style='width: 27%;margin-right: 5px'/>
            <font color="red">
              <span v-if="floatRateType==='1'">算数平均值或加权平均值大于等于最高限价的95%，{{ kvalue }}对应的值为{{ floatRate }}%</span>
              <span v-if="floatRateType==='2'">算数平均值或加权平均值小于最高限价的95%且大于最高限价的 90%，{{ kvalue }}对应的值为{{ floatRate }}%</span>
              <span v-if="floatRateType==='3'">算数平均值或加权平均值小于等于最高限价的 90%，{{ kvalue }}对应的值为{{ floatRate }}%</span>
            </font>
          </a-form-model-item>
        </a-row>
        <a-row :gutter="[16,32]">
          <a-form-model-item :label-col="{span: 4, offset: 4}" :wrapper-col="{span: 4}" label="评标基准价：">
            <a-input :value="benchmarkPrice" disabled='disabled' />
          </a-form-model-item>
        </a-row>
        <a-row :gutter="[16,32]">
          <a-form-model-item :label-col="{span: 4, offset: 4}" :wrapper-col="{span: 8}" label="参与计算投标人评标价：">
            <font color="red">（备注：若抽中方法一，系统会自动判断需要剔除的最高、最低报价）</font>
            <a-table
              ref='table'
              size='middle'
              bordered
              rowKey='bidderId'
              :columns='columns'
              :dataSource='benchmarkPriceList'
              class='j-table-force-nowrap'
            >
              <!--<span slot='action' slot-scope='text, record'>
                <a @click='handleEdit(record)' style='margin-left: 5px'>修改</a>
              </span>-->
            </a-table>
          </a-form-model-item>
        </a-row>
      </div>
    </div>

<!--    <div>-->
<!--      <iframe v-show="stampShowed" ref='signIframe' frameBorder="no" :src="pdfParams.signedPdfUrl" width='100%' height="900" style='border-bottom:1px solid #3D3D3D;'></iframe>-->
<!--    </div>-->

<!--    <stamp :is-stamp='isStamp' ref='stamp' :pdf-params='pdfParams' @checkStampForm='checkStampForm'-->
<!--           @changeIsStamp='changeIsStamp'></stamp>-->
<!--    <SignatureComponent-->
<!--      v-show="stampShowed"-->
<!--      ref="stamp"-->
<!--      :pdf-params="pdfParams"-->
<!--      @checkStampForm="checkStampForm"-->
<!--      @changeIsStamp="changeIsStamp"-->
<!--    ></SignatureComponent>-->

<!--    <SignFileShow-modal ref="modalForm"></SignFileShow-modal>-->

    <div>
      <a-row :gutter="[16,32]">
        <a-col :span="12" :offset="4" style='text-align: center'>
          <a-button type="primary" style="margin-right: 10px" @click="prevStep">上一步</a-button>
<!--          <SignatureButton-->
<!--            v-show="!stampShowed"-->
<!--            ref="SignatureButton"-->
<!--            :pdf-params="pdfParams"-->
<!--            :stampShowed="stampShowed"-->
<!--            :disabled="submitFlag"-->
<!--            @sign="sign"-->
<!--            @signShow="signShow"-->
<!--          ></SignatureButton>-->
<!--          <a-button type='primary' style="margin-left: 10px" v-print="'#pdfCentent'">打印</a-button>-->
          <a-button v-if='!submitFlag' type="primary" style="margin-left: 10px" icon="check-square" @click='okHandel'> 确认</a-button>
        </a-col>
      </a-row>
    </div>
  </a-card>
</template>

<script>
import { postAction,getAction } from '@api/manage'
import stamp from '@/components/Stamp'
import WorkChangeStamp from '@/components/WorkChangeStamp'
import SignatureComponent from '@/components/SignatureComponent'
import SignatureButton from '@/components/SignatureButton'
import SignFileShowModal from '../../modules/SignFileShowModal'
import ARow from 'ant-design-vue/es/grid/Row'
export default {
  name: 'WaterTransportBenchmarkPriceComputeStep5',
  components: { ARow,WorkChangeStamp, stamp ,SignatureComponent,SignatureButton,SignFileShowModal },
  data() {
    return {
      benchmarkPriceAvg:null,
      floatRate: null,
      floatRateType: null,
      kvalue:null,
      benchmarkPriceDown:null,
      benchmarkPrice:null,
      tentativeAmount:null,
      controlPrice:null,
      evalControlPrice:null,
      benchmarkPriceList:[],
      columns: [
        {
          title: '序号',
          dataIndex: '',
          key: 'rowIndex',
          width: 60,
          align: 'center',
          customRender: function(t, r, index) {
            return parseInt(index) + 1
          }
        },
        {
          title: '球号',
          align: 'center',
          dataIndex: 'bidderBall'
        },
        {
          title: '投标人名称',
          align: 'center',
          dataIndex: 'bidderName',
          width: 150
        },
        {
          title: '投标报价金额（元）',
          align: 'center',
          dataIndex: 'bidPrice'
        },
        {
          title: '评标价(元)',
          align: 'center',
          dataIndex: 'evaluationPrice'
        },
        // {
        //   title: '操作',
        //   dataIndex: 'action',
        //   align: 'center',
        //   scopedSlots: { customRender: 'action' }
        // }
      ],
      //是否已提交入围企业
      submitFlag: false,
      //以下签章需要-----------------------
      isStamp: true,
      pdfParams: {
        pageId:"",
        signedPdfUrl: "",
        bidProjectId: "",
        sectionId:"",
        type: 'BenchmarkPrice',
        typeZh: '确认评标基准价签章',
        htmlTitle: '确认评标基准价签章',
        fp: '4',
        saveTmFileFlag:'1',
        signType:'1'//1:统一CA，2：工改签章
      },
      stampShowed: false,
    }
  },
  props: ['sectionId','bidProjectId','workflowInstanceId','instStepId'],
  created() {
    this.pdfParams.bidProjectId = this.bidProjectId;
    this.pdfParams.sectionId = this.sectionId;
    this.setButtonStatus();
    this.getBenchmarkResult();
  },
  methods: {
    setButtonStatus(){
      let that = this
      getAction('/ebid-ce/boOpenStatus/getBoOpenStatus', {
        sectionId: that.sectionId,
      }).then((res) => {
        if (res.success) {
          if(res.result.isKstandPriceFinish==1){
            that.submitFlag = true;
          }else {
            that.submitFlag = false;
          }
        }
      })
    },
    handleEdit(record){
      alert(record.evaluationPrice);
    },
    getBenchmarkResult() {
      getAction('/ebid-ce/waterTransportBenchmarkPriceCompute/getSupervisionBenchmarkResult/' + this.bidProjectId + "/" + this.sectionId, {}).then((res) => {
        if (res.success) {
          this.tentativeAmount = res.result.tentativeAmount;
          this.controlPrice = res.result.controlPrice;
          this.evalControlPrice = res.result.evalControlPrice;
          this.benchmarkPriceDown = res.result.benchmarkPriceDown;
          this.benchmarkPrice = res.result.benchmarkPrice;
          this.floatRate = res.result.floatRate;
          this.floatRateType= res.result.floatRateType;
          this.kvalue= res.result.kvalue;
          this.benchmarkPriceAvg = res.result.benchmarkPriceAvg;
          this.benchmarkPriceList = res.result.benchmarkPriceList;
        }else {
          this.$message.warning(res.message)
        }
      })
    },
    okHandel() {
      let that = this;
      // if (this.$refs.stamp.getPdfUrl() == null) {
      //   this.$message.warn('请先签章');
      //   return;
      // }
      that.$confirm({
        title: '确认信息',
        content: '确认提交评标基准价！',
        onOk() {
          that.submitFlag = true;
          postAction("/ebid-ce/waterTransportBenchmarkPriceCompute/checkKstandPrice/" + that.sectionId+"/"+that.workflowInstanceId+"/"+that.instStepId,{}).then(res=> {
            if (res.success) {
              that.$message.success(res.result)
            } else {
              that.submitFlag = false;
              that.$message.error(res.message)
            }
          }).catch(error => {
            that.submitFlag = false;
            that.$message.error(error)
          })
        },
        onCancel(){
        },
      });
    },
    // /**
    //  * 签章评标基准价计算
    //  */
    // sign(type) {
    //   this.pdfParams.signType = type;
    //   let that = this
    //   this.$confirm({
    //     title: '提示',
    //     content: '您确定要进行签章操作吗？',
    //     onOk() {
    //       //设置本页面标识，用于redis key记录当前页面签章信息
    //       that.pdfParams.pageId = that.sectionId + "_BenchmarkPriceCompute_" + new Date().getTime();
    //       that.$refs.stamp.checkStamp()
    //     },
    //     onCancel(){
    //       that.pdfParams.pageId="";
    //       that.pdfParams.signedPdfUrl="";
    //       that.stampShowed = false;
    //       that.$refs.stamp.pdfUrl=null;
    //     },
    //   })
    // },
    // //签章文件查看
    // signShow() {
    //   this.$refs.modalForm.show(this.sectionId,this.pdfParams.type);
    // },
    //重新编辑
    reEdit(){
      this.pdfParams.pageId="";
      this.pdfParams.signedPdfUrl="";
      this.stampShowed = false;
      this.$refs.stamp.pdfUrl=null;
    },
    // getSignedPdf(){
    //   let that = this;
    //   that.$confirm({
    //     title: '确认信息',
    //     content: '请确认是否已经完成签章，未完成则先完成签章，完成则点击确认获取签章文件！',
    //     onOk() {
    //       that.$refs.stamp.getPdfUrl();
    //     },
    //     onCancel(){
    //     },
    //   })
    // },
    // checkStampForm(callback) {
    //   callback(true)
    // },
    // changeIsStamp(val) {
    //   this.stampShowed = val
    // },
    prevStep () {
      this.$emit('prevStep')
    },
  }
}
</script>

<style scoped>

</style>